import { useCallback } from "react";
import { Modal, Stack, Text } from "@shopify/polaris";

import { useAppDispatch, useAppSelector } from "../../../hooks/redux.js";
import { useAppMutation } from "../../../hooks/index.js";
import { OPEN_MODAL_COLLECTION_WARNING } from "../../../constants/modalTypes.js";
import { closeModal, openModal } from "../../../store/features/modal.js";
import { OPEN_MODAL_SYNC } from "../../../constants/modalTypes.js";

interface ModalProps {
  isOpen: boolean;
  modalType: string;
};

const AllCollectionWarningModal = () => {
  const dispatch = useAppDispatch();
  const { isOpen, modalType } = useAppSelector<ModalProps>((state) => state.modal);

  const { mutate, isLoading } = useAppMutation({
    url: "/api/shop/collection/all",
    reactMutationOptions: {
      onSuccess: () => {
        dispatch(openModal({ modalType: OPEN_MODAL_SYNC }))
      },
      onError: (e) => {
        console.log("e>", e);
      }
    }
  });

  const handleClose = useCallback(() => {
    dispatch(closeModal());
  }, []);

  return (
    <Modal
      open={isOpen && modalType === OPEN_MODAL_COLLECTION_WARNING}
      onClose={handleClose}
      title={
        <Stack spacing="tight" alignment="center">
          <Text as="h3" variant="headingLg">Action necessary</Text>
        </Stack>
      }
      secondaryActions={[{
        content: "Skip",
        onAction: () => dispatch(openModal({ modalType: OPEN_MODAL_SYNC })),
        disabled: isLoading,
      }]}
      primaryAction={{
        content: "Create",
        onAction: () => { mutate({}) },
        loading: isLoading,
      }}
    >
      <Modal.Section>
        <Stack vertical>
          <Text as={"p"} variant={"bodyMd"}>
            To ensure proper functionality for pushing products up or down, an essential "<b><i>All</i></b>" collection is needed, which is currently absent in your store.
            Choose "<b><i>Create</i></b>" to allow Stockhide to create this collection for you.
          </Text>
          <Text as={"p"} variant={"bodyMd"}>
            If you opt to "<b><i>Skip</i></b>", hiding and unhiding products will still work perfectly but pushing up or down products will not.
          </Text>
        </Stack>
      </Modal.Section>
    </Modal>
  );
};

export default AllCollectionWarningModal;

